export default __webpack_public_path__ + "static/rightBackShape-a42a8936ccebe0f5dea3f03bbf1cf04a.png";